import { combineReducers } from "redux";
import authReducer from "./authReducer";
import generalReducer from "./generalReducers";
import playerReducer from "./playerReducers";
import userReducer from "./usersReducers";
import requestCitiesReducer from "./requestCitiesReducer";
import sportRequestReducer from "./sportRequestReducer";
import teamRosterReducer from "./TeamRosterReducer";
import athleteReducer from "./athleteReducer";
import additionalEarningReducer from "./additionalEarningReducer";
import orderReducer from "./orderReducer";
import topicsReducers from "./topicsReducers";
import resetAthleteSummaryReducer from "./resetAthleteSummaryReducer";
import surveyReducer from "./surveyReducer";
import ratingReducer from "./ratingReducer";
import blogReducer from "./blogReducer";
import resolutionReducer from "./resolutionReducer";
import contractRequests from "./ContractRequestsReducer";
import contestReducer from "./contestReducer";
import instituteRequestsReducer from "./instituteRequestsReducer";
import adminEducationReducer from "./adminEducationReducer";
import rvRatingReducer from "./rvRatingReducer";
import AthleteEarningsReducer from "./AthleteEarningsReducer";
import fanDataReducer from "./fanDataReducer";
import DashboardReducers from "./dashboardReducers";
import schoolReducers from "./schoolReducers";
import vendorsReducer from "./vendorsReducer";
import organizerReducer from "./organizerReducer";
import managerReducer from "./managerReducer";
import notificationReducer from "./notificationReducer";
import NewsletterEmailsReducer from "./NewsletterEmailsReducer";
import SportsCommunityBadgeReducer from "./SportsCommunityBadgeReducer";
import gasFeeReducer from "./gasFeeReducers";
import adminBoostReducer from "./adminBoostReducer";
const rootReducer = combineReducers({
  resetSummary: resetAthleteSummaryReducer,
  auth: authReducer,
  players: playerReducer,
  users: userReducer,
  general: generalReducer,
  requestcities: requestCitiesReducer,
  requestSports: sportRequestReducer,
  teamrosters: teamRosterReducer,
  athlete: athleteReducer,
  earnings: additionalEarningReducer,
  order: orderReducer,
  a4bTopics: topicsReducers,
  survey: surveyReducer,
  rating: ratingReducer,
  resolution: resolutionReducer,
  blog: blogReducer,
  ContractRequest: contractRequests,
  contest: contestReducer,
  requestInstitute: instituteRequestsReducer,
  adminEducation: adminEducationReducer,
  rvRating: rvRatingReducer,
  athleteEarnings: AthleteEarningsReducer,
  fans: fanDataReducer,
  dashboard: DashboardReducers,
  school: schoolReducers,
  vendor: vendorsReducer,
  organizer: organizerReducer,
  manager: managerReducer,
  notifications: notificationReducer,
  newsletter: NewsletterEmailsReducer,
  sportsCommunityBadge: SportsCommunityBadgeReducer,
  gasFee: gasFeeReducer,
  adminBoost: adminBoostReducer,
});
export default rootReducer;
